import { apiClientConfig } from "@/utils/api-utils"
import { LabOrderFacadeTypeEnum, LabOrderRequestStatusEnum, MedicalApi } from "@vitable/asclepius-api-client-ts"
import { uselistLabOrdersFacade } from "@/composables/lab-orders-facade"

const state = () => ({
  labOrderCounts: {
    resultsReceived: 0
  },
  manualLabResultCounts: {
    unreviewed: 0
  }
})

const getters = {
  totalLabItemsNeedingAttention: (state) => {
    return state.labOrderCounts.resultsReceived + state.manualLabResultCounts.unreviewed
  },

  totalLabOrdersNeedingAttention: (state) => {
    return state.labOrderCounts.resultsReceived
  }
}

const actions = {
  refreshAllCounts({ dispatch }) {
    dispatch("getLabOrderCounts")
    dispatch("getManualLabResultCounts")
  },

  refreshLabOrderCounts({ dispatch }) {
    dispatch("getLabOrderCounts")
  },

  refreshManualLabResultCounts({ dispatch }) {
    dispatch("getManualLabResultCounts")
  },

  async getLabOrderCounts({ commit }) {
    const { labOrders, listLabOrders } = uselistLabOrdersFacade()

    try {
      await listLabOrders({
        facadeType: LabOrderFacadeTypeEnum.OrderRequest,
        status: LabOrderRequestStatusEnum.ResultsReceived
      })

      commit("setLabOrderCounts", {
        resultsReceivedCount: labOrders.total
      })
    } catch (e) {
      console.error(`Failed to getLabOrderCounts - ${e}`)
      throw new Error(e)
    }
  },

  async getManualLabResultCounts({ commit, rootGetters }) {
    if (!rootGetters["me/isClinicalAdmin"]) return

    try {
      const medicalApi = new MedicalApi(apiClientConfig())

      const unreviewedCount = (
        await medicalApi.listManualLabResults({
          reviewedIn: false
        })
      ).data.count

      commit("setManualLabResultCounts", {
        unreviewedCount: unreviewedCount
      })
    } catch (e) {
      console.error(`Failed to getManualLabResultCounts - ${e}`)
      throw new Error(e)
    }
  }
}

const mutations = {
  setLabOrderCounts(state, { resultsReceivedCount }) {
    state.labOrderCounts.resultsReceived = resultsReceivedCount
  },

  setManualLabResultCounts(state, { unreviewedCount }) {
    state.manualLabResultCounts.unreviewed = unreviewedCount
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
